import React, { Fragment } from "react";
import logoExpanded from "../../assets/brand/cryr-logo.png";
import logoCollapsed from "../../assets/brand/logo.png";
import { connect } from "react-redux";

import Hamburger from "hamburger-react";

import AppMobileMenu from "../AppMobileMenu";

import {
  setEnableClosedSidebar,
  setEnableMobileMenu,
  setEnableMobileMenuSmall,
} from "../../reducers/ThemeOptions";

class HeaderLogo extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      active: false,
      mobile: false,
      activeSecondaryMenuMobile: false,
    };
  }

  toggleEnableClosedSidebar = () => {
    let { enableClosedSidebar, setEnableClosedSidebar } = this.props;
    setEnableClosedSidebar(!enableClosedSidebar);
  };

  state = {
    openLeft: false,
    openRight: false,
    relativeWidth: false,
    width: 280,
    noTouchOpen: false,
    noTouchClose: false,
  };

  render() {
    const { enableClosedSidebar } = this.props;
    const isCollapsed = !!enableClosedSidebar;
    return (
      <Fragment>
        <div className="app-header__logo">
          <div className="w-100" style={{ position: 'relative', height: 32 }}>
            {/* Expanded logo */}
            <img
              src={logoExpanded}
              alt="Automyze"
              style={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: `translate(-50%, -50%) scale(${isCollapsed ? 0.95 : 1})`,
                height: 28,
                width: 'auto',
                opacity: isCollapsed ? 0 : 1,
                transition: 'opacity 220ms ease, transform 220ms ease',
              }}
            />
            {/* Collapsed logo */}
            <img
              src={logoCollapsed}
              alt="Automyze Collapsed"
              style={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: `translate(-50%, -50%) scale(${isCollapsed ? 1 : 0.95})`,
                height: 24,
                width: 'auto',
                opacity: isCollapsed ? 1 : 0,
                transition: 'opacity 220ms ease, transform 220ms ease',
              }}
            />
          </div>
        </div>
        <AppMobileMenu />
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  enableClosedSidebar: state.ThemeOptions.enableClosedSidebar,
  enableMobileMenu: state.ThemeOptions.enableMobileMenu,
  enableMobileMenuSmall: state.ThemeOptions.enableMobileMenuSmall,
});

const mapDispatchToProps = (dispatch) => ({
  setEnableClosedSidebar: (enable) => dispatch(setEnableClosedSidebar(enable)),
  setEnableMobileMenu: (enable) => dispatch(setEnableMobileMenu(enable)),
  setEnableMobileMenuSmall: (enable) =>
    dispatch(setEnableMobileMenuSmall(enable)),
});

export default connect(mapStateToProps, mapDispatchToProps)(HeaderLogo);
